module.exports = __webpack_public_path__ + "img/accepted_inactive.b9454c6d.png";